import { Controller } from "@hotwired/stimulus";
import DOMPurify from "dompurify";

// import Rails from "rails";
export default class extends Controller {
  static targets = ["reeInput"];

  buildUserOptions(results) {
    return results.users
      .map((user) => {
        return `<option value="${DOMPurify.sanitize(
          user.id
        )}">${DOMPurify.sanitize(user.name)}</option>`;
      })
      .join("\n");
  }

  updateReesList(id = null, count = null) {
    const enterpriseId = id || event.target.value;
    const inputCount = count || event.target.dataset.count;
    const target = this.reeInputTarget;
    const path = "/enterprises/" + enterpriseId + ".json";
    target.innerHTML = "";
    $.get(path)
      .done((results) => {
        const options = this.buildUserOptions(results);
        target.innerHTML = options;
      })
      .fail((err) => (target.innerHTML = ""));
  }

  loadRees(event) {
    const id = event.currentTarget.dataset.id || event.currentTarget.value;
    const name =
      event.currentTarget.dataset.name ||
      event.currentTarget.selectedOptions[0].label;
    const newOption = new Option(name, id, true, true);
    event.currentTarget.add(newOption);
    // Need to update list of corresponding REEs. To do that, need to pass the counter of EE inputs, in case there are multiple ones
    const inputCount = event.currentTarget.dataset.count;
    this.updateReesList(id, inputCount);
  }
}
